import React, {PureComponent} from 'react';
import {connect} from 'dva';
import {FormattedMessage, injectIntl} from 'react-intl';
import {Input, Modal, Switch, InputNumber, Radio} from 'antd';
import './PolicyManage.less';
import {Btn} from '../../components/Widgets';

class PolicyManage extends PureComponent {
  constructor() {
    super();
  }

  componentWillMount() {
  }

  render() {
    const {dispatch, meetingPolicy = {}, intl, cospacesBulk = {}, remindTime} = this.props;
    const {
      meetingRoomLock = 0,
      meetingRoomLockTime = 15,
      signInNotice = 0,
      noticeTimeBefore = 5,
      noticeTimeAfter = 5,
      cmmaMeetingState = 1,
      meetingLock = 1,
      showReserveBtn = 1,
      roomMaintain = 1,
      willEndRemind = 0,
      willEndRemindTime = 10,
      showMeetingSign = 0,
      showMeetingSvc = 0,
      cleanerNotice = 0,
      showMeetingAgenda = 0,
      showMeetingDevice = 0,
      webExMeetingState = 0,
      showRoomsForWebEx = 0,
      advanceAuditTime = 10,
      allowRmAdModify = 0,
      forbidReserSameTime,
      holidayState = 1,
      monitorSwitch = 0,
      showQrCode = 1,
      cycleMeetingSwitch = 1,
      cycleMeetingDays = 30,
      maintainSwitch = 1,
      visibleSwitch = 1,
      staffAuth = 0,
      passwordAuth = 1,
      qrcodeAuth = 1,
      defaultAuthType = 1,
      showMutilRoomsChoice = 1,
      showMeetingPrivateInfo = 1,
      meetingRoomSync = 0,
      allowMeetingCrossDays = 0,
      cycleMeetingAudit = 0,
      billingSwitch = 0
    } = meetingPolicy;
    const openTypes = [];
    if (1 == staffAuth) {
      openTypes.push(0);
    }
    if (1 == passwordAuth) {
      openTypes.push(1);
    }
    if (1 == qrcodeAuth) {
      openTypes.push(2);
    }
    let showDefaultAuth = defaultAuthType;
    if (openTypes.length > 0) {
      if (openTypes.indexOf(defaultAuthType) == -1) {
        showDefaultAuth = openTypes[0];
      }
    } else {
      showDefaultAuth = -1;
    }

    const {cospacesBulkName, cospacesCount, startIndex, available} = cospacesBulk;

    return (
      <div className="policy-manage">
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_meeting_lock_time"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_meeting_lock_time_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_if_lock"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={meetingRoomLock === 1}
                  onChange={value => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          meetingRoomLock: value ? 1 : 0
                        }
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_time"/> :{' '}
              </label>
              <div className="notice-control">
                <div style={{width: '70px'}}>
                  <Input
                    value={meetingRoomLockTime}
                    onChange={e => {
                      dispatch({
                        type: 'account/update',
                        payload: {
                          meetingPolicy: {
                            ...meetingPolicy,
                            meetingRoomLockTime: e.target.value
                          }
                        }
                      });
                    }}
                  />
                </div>
              </div>
              <span style={{marginLeft: '10px'}}>
              <FormattedMessage id="policy_manage_minute"/>
            </span>
            </div>
            <div className="operate_btn_div">
              <Btn
                primary
                onClick={() => {
                  let reg = new RegExp('^\\d+$');
                  if (!reg.test(meetingRoomLockTime) || parseInt(meetingRoomLockTime) > 1440) {
                    Modal.error({
                      content: '请输入正确的会议锁定时间（整数，0-1440）'
                    });
                    return;
                  }
                  const promise = new Promise((resolve, reject) => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy,
                      resolve,
                      reject
                    });
                  });
                  promise.then(
                    () => {
                      Modal.success({
                        content: intl.formatMessage({id: 'index_save_success'})
                      });
                    },
                    msg => {
                      Modal.error({content: msg});
                    }
                  );
                }}
              >
                <FormattedMessage id="policy_manage_btn_save"/>
              </Btn>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_unrepresented_reminder"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_unrepresented_reminder_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_if_notice"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={signInNotice === 1}
                  onChange={value => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          signInNotice: value ? 1 : 0
                        }
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_before_meeting"/> :{' '}
              </label>
              <div className="notice-control">
                <div style={{width: '70px'}}>
                  <Input
                    value={noticeTimeBefore}
                    onChange={e => {
                      dispatch({
                        type: 'account/update',
                        payload: {
                          meetingPolicy: {
                            ...meetingPolicy,
                            noticeTimeBefore: e.target.value
                          }
                        }
                      });
                    }}
                  />
                </div>
              </div>
              <span style={{marginLeft: '10px'}}>
              <FormattedMessage id="policy_manage_minute"/>
            </span>
            </div>
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_after_meeting"/> :{' '}
              </label>
              <div className="notice-control">
                <div style={{width: '70px'}}>
                  <Input
                    value={noticeTimeAfter}
                    onChange={e => {
                      dispatch({
                        type: 'account/update',
                        payload: {
                          meetingPolicy: {
                            ...meetingPolicy,
                            noticeTimeAfter: e.target.value
                          }
                        }
                      });
                    }}
                  />
                </div>
              </div>
              <span style={{marginLeft: '10px'}}>
              <FormattedMessage id="policy_manage_minute"/>
            </span>
            </div>
            <div className="operate_btn_div">
              <Btn
                primary
                onClick={() => {
                  let reg = new RegExp('^\\d+$');
                  if (!reg.test(noticeTimeBefore)) {
                    Modal.error({
                      content: '请输入正确的会议开始前提醒时间（非负整数）'
                    });
                    return;
                  }
                  if (!reg.test(noticeTimeAfter)) {
                    Modal.error({
                      content: '请输入正确的会议开始后提醒时间（非负整数）'
                    });
                    return;
                  }
                  const promise = new Promise((resolve, reject) => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy,
                      resolve,
                      reject
                    });
                  });
                  promise.then(
                    () => {
                      Modal.success({
                        content: intl.formatMessage({id: 'index_save_success'})
                      });
                    },
                    msg => {
                      Modal.error({content: msg});
                    }
                  );
                }}
              >
                <FormattedMessage id="policy_manage_btn_save"/>
              </Btn>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_meeting_check_in_time"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_meeting_check_in_time_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_meeting_check_in_time"/>&nbsp;:&nbsp;
              </label>
              <FormattedMessage id="policy_manage_sign_time_label"/>
              <div className="notice-control">
                <div style={{width: '70px'}}>
                  <Input
                    value={Number(meetingPolicy.signTime)}
                    onChange={e => {
                      dispatch({
                        type: 'account/update',
                        payload: {
                          meetingPolicy: {
                            ...meetingPolicy,
                            signTime: e.target.value
                          }
                        }
                      });
                    }}
                  />
                </div>
              </div>
              <span style={{marginLeft: '10px'}}>
              <FormattedMessage id="policy_manage_minute"/>
            </span>
            </div>
            <div className="operate_btn_div">
              <Btn
                primary
                onClick={() => {
                  const promise = new Promise((resolve, reject) => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy,
                      resolve,
                      reject
                    });
                  });
                  promise.then(
                    () => {
                      Modal.success({
                        content: intl.formatMessage({id: 'index_save_success'})
                      });
                    },
                    msg => {
                      Modal.error({content: msg});
                    }
                  );
                }}
              >
                <FormattedMessage id="policy_manage_btn_save"/>
              </Btn>
            </div>
          </div>
        </div>


        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_meeting_remind_time"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_meeting_remind_time_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_before_meeting_start"/> :{' '}
              </label>
              <div className="notice-control">
                <div style={{width: '70px'}}>
                  <Input
                    value={remindTime}
                    onChange={e => {
                      dispatch({
                        type: 'account/update',
                        payload: {remindTime: e.target.value}
                      });
                    }}
                  />
                </div>
              </div>
              <span style={{marginLeft: '10px'}}>
              <FormattedMessage id="policy_manage_minute"/>
            </span>
            </div>
            <div className="operate_btn_div">
              <Btn
                primary
                onClick={() => {
                  let reg = new RegExp('^\\d+$');
                  if (!reg.test(remindTime) || remindTime < 1) {
                    Modal.error({
                      content: '请输入正确的会议开始前时间（正整数）'
                    });
                    return;
                  }
                  const promise = new Promise((resolve, reject) => {
                    dispatch({
                      type: 'account/saveRemindTime',
                      remindTime,
                      resolve,
                      reject
                    });
                  });
                  promise.then(
                    () => {
                      Modal.success({
                        content: intl.formatMessage({id: 'index_save_success'})
                      });
                    },
                    msg => {
                      Modal.error({content: msg});
                    }
                  );
                }}
              >
                <FormattedMessage id="policy_manage_btn_save"/>
              </Btn>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_meeting_willend_time"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_meeting_willend_time_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_if_notice"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={willEndRemind === 1}
                  onChange={value => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          willEndRemind: value ? 1 : 0
                        }
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_before_meeting_end"/> :{' '}
              </label>
              <div className="notice-control">
                <div style={{width: '70px'}}>
                  <Input
                    value={willEndRemindTime}
                    onChange={e => {
                      dispatch({
                        type: 'account/update',
                        payload: {
                          meetingPolicy: {
                            ...meetingPolicy,
                            willEndRemindTime: e.target.value
                          }
                        }
                      });
                    }}
                  />
                </div>
              </div>
              <span style={{marginLeft: '10px'}}>
              <FormattedMessage id="policy_manage_minute"/>
            </span>
            </div>
            <div className="operate_btn_div">
              <Btn
                primary
                onClick={() => {
                  let reg = new RegExp('^\\d+$');
                  if (!reg.test(willEndRemindTime)) {
                    Modal.error({
                      content: '请输入正确的会议结束前时间（非负整数）'
                    });
                    return;
                  }
                  const promise = new Promise((resolve, reject) => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy,
                      resolve,
                      reject
                    });
                  });
                  promise.then(
                    () => {
                      Modal.success({
                        content: intl.formatMessage({id: 'index_save_success'})
                      });
                    },
                    msg => {
                      Modal.error({content: msg});
                    }
                  );
                }}
              >
                <FormattedMessage id="policy_manage_btn_save"/>
              </Btn>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_meeting_lock"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_meeting_lock_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_if_lock"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!meetingLock}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        meetingLock: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_room_maintain"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_room_maintain_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                是否启用 :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!roomMaintain}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        roomMaintain: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_display_board_btn_switch"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_display_board_btn_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_if_show"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!showReserveBtn}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        showReserveBtn: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">展板二维码开关</span>
            <span className="search-line-subtitle">是否需要在展板显示二维码功能</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!showQrCode}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        showQrCode: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">展板监控配置</span>
            <span className="search-line-subtitle">是否开启展板监控服务</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!monitorSwitch}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        monitorSwitch: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            视频会议开关
            {/*<FormattedMessage id="policy_manage_display_board_btn_switch"/>*/}
          </span>
            <span className="search-line-subtitle">
            是否需要视频会议功能
              {/*<FormattedMessage id="policy_manage_display_board_btn_content"/>*/}
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                是否启用 :{/*<FormattedMessage id="policy_manage_if_lock"/> : */}
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!cmmaMeetingState}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        cmmaMeetingState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
            {
              cmmaMeetingState === 1 &&
              <div className="cospaces-bulk">
                {
                  !available &&
                  <div
                    className="cospaces-bulk-mask"
                    onClick={e => e.stopPropagation()}
                  >
                    {'CMMA服务状态异常！'}
                  </div>
                }
                <div className="notice-item">
                  <label>
                    coSpace起始号码 :
                  </label>
                  <div className="notice-control">
                    <div style={{width: '70px'}}>
                      <InputNumber
                        value={startIndex || 0}
                        min={0}
                        disabled={!available}
                        onChange={value => {
                          dispatch({
                            type: 'account/update',
                            payload: {
                              cospacesBulk: {
                                ...cospacesBulk,
                                startIndex: value
                              }
                            }
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="notice-item">
                  <label>
                    coSpace数量 :
                  </label>
                  <div className="notice-control">
                    <div style={{width: '70px'}}>
                      <InputNumber
                        value={cospacesCount || 0}
                        min={0}
                        disabled={!available}
                        onChange={value => {
                          dispatch({
                            type: 'account/update',
                            payload: {
                              cospacesBulk: {
                                ...cospacesBulk,
                                cospacesCount: value
                              }
                            }
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="notice-item">
                  <label>
                    coSpace系统名称 :
                  </label>
                  <div className="notice-control">
                    <div style={{width: '150px'}}>
                      <Input
                        value={cospacesBulkName || ''}
                        disabled={!available}
                        onChange={e => {
                          dispatch({
                            type: 'account/update',
                            payload: {
                              cospacesBulk: {
                                ...cospacesBulk,
                                cospacesBulkName: e.target.value
                              }
                            }
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="operate_btn_div">
                  <Btn
                    primary
                    onClick={() => {
                      if (!available || cospacesBulkName === '' || cospacesCount <= 0 || startIndex <= 0) {
                        Modal.error({
                          content: '请输入正确的coSpaces Bulk信息'
                        });
                        return
                      } else {
                        Modal.confirm({
                          title: '确认同步coSpaces',
                          content: '同步coSpaces会关闭修改范围内coSpaces上正在召开的会议！',
                          okText: '确认',
                          cancelText: '取消',
                          onOk: () => {
                            dispatch({type: 'account/syncCmmaCospacesBulk'})
                          }
                        })
                      }
                    }}
                  >
                    同步
                  </Btn>
                </div>
              </div>
            }
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">展板端用户认证配置</span>
            <span className="search-line-subtitle">
            关闭开关后，以下功能将不在展板端身份认证时显示
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                编号认证 :
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!staffAuth}
                  onChange={value => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          staffAuth: value ? 1 : 0,
                          passwordAuth: value ? 0 : passwordAuth
                        }
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                密码认证 :
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!passwordAuth}
                  onChange={value => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          passwordAuth: value ? 1 : 0,
                          staffAuth: value ? 0 : staffAuth
                        }
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                扫码认证 :
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!qrcodeAuth}
                  onChange={value => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          qrcodeAuth: value ? 1 : 0
                        }
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                默认认证方式 :
              </label>
              <div className="notice-control">
                <Radio.Group
                  value={showDefaultAuth}
                  onChange={e => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          defaultAuthType: e.target.value
                        }
                      }
                    });
                  }}>
                  <Radio value={0} disabled={!staffAuth}>编号认证</Radio>
                  <Radio value={1} disabled={!passwordAuth}>密码认证</Radio>
                  <Radio value={2} disabled={!qrcodeAuth}>扫码认证</Radio>
                </Radio.Group>
              </div>
            </div>
            <div className="operate_btn_div">
              <Btn
                primary
                onClick={() => {
                  if (0 == staffAuth && 0 == passwordAuth && 0 == qrcodeAuth) {
                    Modal.error({content: "展板端用认证方式不能全部关闭！"});
                  } else {
                    const promise = new Promise((resolve, reject) => {
                      meetingPolicy.defaultAuthType = showDefaultAuth;
                      dispatch({
                        type: 'account/saveMeetingPolicy',
                        meetingPolicy,
                        resolve,
                        reject
                      });
                    });
                    promise.then(
                      () => {
                        Modal.success({
                          content: intl.formatMessage({id: 'index_save_success'})
                        });
                      },
                      msg => {
                        Modal.error({content: msg});
                      }
                    );
                  }
                }}
              >
                <FormattedMessage id="policy_manage_btn_save"/>
              </Btn>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_webex_btn_switch"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_webex_btn_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>是否启用 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!webExMeetingState}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        webExMeetingState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>

            {!!webExMeetingState && (
              <div className="notice-item">
                <label>是否同时预约物理会议室 :</label>
                <div className="notice-control">
                  <Switch
                    checked={!!showRoomsForWebEx}
                    onChange={value => {
                      dispatch({
                        type: 'account/saveMeetingPolicy',
                        meetingPolicy: {
                          ...meetingPolicy,
                          showRoomsForWebEx: value ? 1 : 0
                        }
                      });
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_meeting_function_btn_switch"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_meeting_function_btn_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_meeting_sign"/> :
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!showMeetingSign}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        showMeetingSign: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_meeting_svc"/> :
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!showMeetingSvc}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        showMeetingSvc: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_meeting_device"/> :
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!showMeetingDevice}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        showMeetingDevice: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
            <div className="notice-item">
              <label>
                <FormattedMessage id="policy_manage_meeting_agenda"/> :
              </label>
              <div className="notice-control">
                <Switch
                  checked={!!showMeetingAgenda}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        showMeetingAgenda: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="policy_manage_meeting_cleaner_btn_switch"/>
          </span>
            <span className="search-line-subtitle">
            <FormattedMessage id="policy_manage_meeting_cleaner_btn_content"/>
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>是否启用 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!cleanerNotice}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        cleanerNotice: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">节假日控制开关</span>
            <span className="search-line-subtitle">是否允许在节假日预约会议</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>是否启用 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!holidayState}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        holidayState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">待审核会议需提前审批时间</span>
            <span className="search-line-subtitle">
            若在会议开始前规定时间内没有被审批，该会议将会被取消
          </span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>会议开始前： </label>
              <div className="notice-control">
                <div style={{width: '70px'}}>
                  <Input
                    value={advanceAuditTime}
                    onChange={e => {
                      dispatch({
                        type: 'account/update',
                        payload: {
                          meetingPolicy: {
                            ...meetingPolicy,
                            advanceAuditTime: e.target.value
                          }
                        }
                      });
                    }}
                  />
                </div>
              </div>
              <span style={{marginLeft: '10px'}}>
              <FormattedMessage id="policy_manage_minute"/>
            </span>
            </div>
            <div className="operate_btn_div">
              <Btn
                primary
                onClick={() => {
                  let reg = new RegExp('^\\d+$');
                  if (!reg.test(advanceAuditTime)) {
                    Modal.error({
                      content: '请输入正确的提前审批时间（非负整数）'
                    });
                    return;
                  }
                  const promise = new Promise((resolve, reject) => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy,
                      resolve,
                      reject
                    });
                  });
                  promise.then(
                    () => {
                      Modal.success({
                        content: intl.formatMessage({id: 'index_save_success'})
                      });
                    },
                    msg => {
                      Modal.error({content: msg});
                    }
                  );
                }}
              >
                <FormattedMessage id="policy_manage_btn_save"/>
              </Btn>
            </div>
          </div>
        </div>
        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">是否允许会议室管理员修改会议</span>
            <span className="search-line-subtitle">打开后，会议室管理员可以取消、修改、延长或结束其管理的会议室下的会议</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>是否启用 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!allowRmAdModify}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        allowRmAdModify: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>


        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">会议预约配置</span>
            <span className="search-line-subtitle">禁止同一账号在相同时间预约多个会议。</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!forbidReserSameTime}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        forbidReserSameTime: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">会议室维护开关</span>
            <span className="search-line-subtitle">是否开启会议室维护功能</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!maintainSwitch}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        maintainSwitch: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">会议室启用/停用开关</span>
            <span className="search-line-subtitle">是否开启会议室启用/停用功能</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!visibleSwitch}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        visibleSwitch: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">多会议室预约开关</span>
            <span className="search-line-subtitle">是否允许预约多会议室会议</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!showMutilRoomsChoice}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        showMutilRoomsChoice: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">是否公开会议主题和预订人</span>
            <span className="search-line-subtitle">是否公开会议主题和预订人</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!showMeetingPrivateInfo}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        showMeetingPrivateInfo: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">会议室账户开关</span>
            <span className="search-line-subtitle">会议室账户作为CalendarId同步会议</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!meetingRoomSync}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        meetingRoomSync: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">长期会议开关</span>
            <span className="search-line-subtitle">是否允许预约长期会议</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!allowMeetingCrossDays}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        allowMeetingCrossDays: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>


        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">预约会议会议室是否计费</span>
            <span className="search-line-subtitle">预约会议会议室是否计费</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>开关 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!billingSwitch}
                  onChange={value => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy: {
                        ...meetingPolicy,
                        billingSwitch: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="policy-item">
          <div className="notice-title">
            <span className="search-line-title">周期会议配置</span>
            <span className="search-line-subtitle">是否允许预约周期会议</span>
          </div>
          <div className="notice-content">
            <div className="notice-item">
              <label>是否允许预约 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!cycleMeetingSwitch}
                  onChange={value => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          cycleMeetingSwitch: value ? 1 : 0
                        }
                      }
                    });
                  }}
                />
              </div>
            </div>
            {!!cycleMeetingSwitch && <div className="notice-item">
              <label>是否需要审核 :</label>
              <div className="notice-control">
                <Switch
                  checked={!!cycleMeetingAudit}
                  onChange={value => {
                    dispatch({
                      type: 'account/update',
                      payload: {
                        meetingPolicy: {
                          ...meetingPolicy,
                          cycleMeetingAudit: value ? 1 : 0
                        }
                      }
                    });
                  }}
                />
              </div>
            </div>}
            <div className="notice-item">
              <label>周期会议最长天数 （包含节假日和工作日）:</label>
              <div className="notice-control">
                <div style={{width: '70px'}}>
                  <InputNumber
                    min={1}
                    max={180}
                    value={cycleMeetingDays}
                    onChange={value => {
                      dispatch({
                        type: 'account/update',
                        payload: {
                          meetingPolicy: {
                            ...meetingPolicy,
                            cycleMeetingDays: value
                          }
                        }
                      });
                    }}
                  />
                </div>
              </div>
              <span style={{marginLeft: '20px'}}>
                <FormattedMessage id="policy_manage_day"/>
              </span>
            </div>
            <div className="operate_btn_div">
              <Btn
                primary
                onClick={() => {
                  const promise = new Promise((resolve, reject) => {
                    dispatch({
                      type: 'account/saveMeetingPolicy',
                      meetingPolicy,
                      resolve,
                      reject
                    });
                  });
                  promise.then(
                    () => {
                      Modal.success({
                        content: intl.formatMessage({id: 'index_save_success'})
                      });
                    },
                    msg => {
                      Modal.error({content: msg});
                    }
                  );
                }}
              >
                <FormattedMessage id="policy_manage_btn_save"/>
              </Btn>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {meetingPolicy = {}, cospacesBulk = {}, remindTime = 1} = state.account;
  return {meetingPolicy, cospacesBulk, remindTime};
};

export default connect(mapStateToProps)(injectIntl(PolicyManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/PolicyManage.js